import axios from 'axios';
import { useStorage } from '../hooks/use-storage';

function useMapAPI() {
  const { userRef, menuIdRef, languageRef } = useStorage();

  function saveMapBaseLocationFromRemote(placeDetails) {
    const url = `/vbeta2/map/location`;

    return axios({
      url,
      method: 'post',
      data: placeDetails,
      headers: {
        Authorization: `Bearer ${userRef?.current?.token}`,
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
    });
  }

  return {
    saveMapBaseLocationFromRemote,
  };
}

export { useMapAPI };
